import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ContactForm from './components/ContactForm';
import ContactInfo from './components/ContactInfo';

const ContactPage = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash === '#contact-form') {
      setTimeout(() => {
        const el = document.getElementById('contact-form');
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 150);
    }
  }, [hash]);

  return (
    <>
      <title>Contact & Devis Décoration Abidjan | Ev & Co Design</title>
      <meta
        name="description"
        content="Demandez un devis personnalisé pour votre projet de décoration événementielle, d'intérieur ou de création 3D à Abidjan. Studio Ev & Co Design – Côte d'Ivoire."
      />
      <meta name="keywords" content="devis décoration Abidjan, contact studio design Côte d'Ivoire, demande devis décoration événementielle" />
      <link rel="canonical" href="https://evcodesign-ci.com/contact" />

      <div className="min-h-screen bg-[#FAF8F5]">
        <Navbar />

        {/* Hero banner */}
        <section className="relative pt-32 pb-20 px-6 overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=luxury%20interior%20design%20studio%20elegant%20workspace%20Abidjan%20Ivory%20Coast%20modern%20minimal%20desk%20flowers%20beige%20tones%20sophisticated%20bright%20professional%20high%20end%20atelier%20warm%20natural%20light&width=1400&height=500&seq=evco_contact_hero01&orientation=landscape"
              alt="Contact Ev & Co Design"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30" />
          </div>
          <div className="relative max-w-3xl mx-auto text-center">
            <div className="inline-flex items-center gap-2 mb-5">
              <span className="h-px w-6 bg-brand-coral" />
              <span className="text-brand-coral text-xs font-medium tracking-[0.2em] uppercase">Contact &amp; Devis</span>
              <span className="h-px w-6 bg-brand-coral" />
            </div>
            <h1 className="font-serif text-4xl lg:text-5xl text-white leading-tight mb-5">
              Donnons vie à votre projet
            </h1>
            <p className="text-white/80 leading-relaxed text-lg">
              Décrivez-nous votre vision — nous vous proposons une solution sur-mesure, élégante et unique.
            </p>
          </div>
        </section>

        {/* Main content */}
        <section id="contact-form" className="py-20 px-6 scroll-mt-24">
          <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-5 gap-12">
            <div className="lg:col-span-2">
              <ContactInfo />
            </div>
            <div className="lg:col-span-3">
              <ContactForm />
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
};

export default ContactPage;
